// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandName-root-2PUto","md":"BrandName-md-2O7iB","lg":"BrandName-lg-5E_ks"};